/* eslint-disable */
export default abstract class ModelAbstract {
	ModelAbstract(data: any): void {}
	protected abstract mapData(): void;
	abstract validate(data: any): string;

}
